import React from 'react';
import { IntlProvider } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';
import Language, { Locale } from './language';
import { authStateSelector, AUTH_STATE_KEY } from './auth/auth-reducer';
import { authCreators } from './auth/auth-action';
import { getLocalStorage, isBoolean } from './shared/helpers/utility';
import { AUTH_LOCAL_STORAGE_KEY, COGNITO_CHALLENGE } from './auth/auth-constant';
import { generalCreators } from './redux/general/general-action';
import { GENERAL_STATE_KEY, generalStateSelector } from './redux/general/general-reducer';
import { MODAL_TYPE } from './redux/general/general-constant';
import { WrapperIntlProvider } from './shared/helpers/test-helper';

export default function AppProvider({ children }: any) {
  const dispatch = useDispatch();
  const locale = (useSelector(generalStateSelector(GENERAL_STATE_KEY.LOCALE)) || 'th') as string;

  // Check chrome or safari
  const ua = navigator.userAgent.toLowerCase();
  if (ua.indexOf('safari') !== -1) {
      const version = ua.indexOf('version/');
      const safariVersionNumber = parseFloat(ua.substr(version + 8, 2));
      if (safariVersionNumber < 13) {
        dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.CHECK_BROWSER_NOT_SUPPORT, true));
      }
  }

  // Check isLogin
  const reduxIsLogin = useSelector(authStateSelector(AUTH_STATE_KEY.ID_TOKEN));
  const remember = isBoolean(getLocalStorage(AUTH_LOCAL_STORAGE_KEY.IS_REMEMBER));
  const localIsLogin = getLocalStorage(AUTH_LOCAL_STORAGE_KEY.ID_TOKEN);
  const email = getLocalStorage(AUTH_LOCAL_STORAGE_KEY.EMAIL);

  if (email) {
    dispatch(authCreators.setAuthState(AUTH_STATE_KEY.EMAIL, email));
  }
  if (!reduxIsLogin) {
    if (remember) {
      if (localIsLogin) {
       dispatch(authCreators.setAuthState(AUTH_STATE_KEY.ID_TOKEN, localIsLogin));
       dispatch(authCreators.setAuthState(AUTH_STATE_KEY.STATUS, COGNITO_CHALLENGE.LOGIN_SUCCESS));
      }
    } else {
      const expire = parseInt(getLocalStorage(AUTH_LOCAL_STORAGE_KEY.EXPIRE_TIME) || '');
      if (expire) {
        if (new Date(expire).getTime() > new Date().getTime()) {
          if (localIsLogin) {
           dispatch(authCreators.setAuthState(AUTH_STATE_KEY.ID_TOKEN, localIsLogin));
           dispatch(authCreators.setAuthState(AUTH_STATE_KEY.STATUS, COGNITO_CHALLENGE.LOGIN_SUCCESS));
          }
        } else {
          dispatch(authCreators.logOut());
          dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
            visible: true,
            modalTitle: 'main.error.timeout.title',
            modalContent: 'main.error.timeout.content',
            type: MODAL_TYPE.ERROR
          }));
        }
      }
    }
  }

  if (process.env.NODE_ENV === 'test') {
    return (
      WrapperIntlProvider(children)
    );
  } else {
    const currentLanguage = Language(locale as Locale);
    return (
      <IntlProvider
        locale={currentLanguage.locale}
        messages={currentLanguage.lang.messages}>
        {children}
      </IntlProvider>
    );
  }
}
